import { config } from '../../../shared/config';
import { useOnboardingStore } from '../../../shared/store';
// import { deliveryAssessmentIdsMapping } from '../constants/assessment-constants';
import { PREFERENCES_SKILLS_FORM_INITIAL_VALUE, PREFERENCES_DEFAULT_VALUE } from '../constants/preferences-constants';
import { STEP_THREE_INITIAL_VALUES } from '../constants/step-three-constants';
import { DeliveryAssessmentResponseType, DeliveryQuestionKey, PreferencesFormDeliveryDataType, TelecallerAssessmentResponseType } from '../types/assessment-types';
import { NBJobLocationSearchData, NBPreferredLocationData } from '../types/step-four-types';
import { LanguagesKnownType } from '../types/step-two-types';
import { LanguagesKnown, Profile } from './../../../hooks/use-get-profile';

export const transformDataPreferenceSkillData = (data: Profile) => ({
    addedSkills: (data?.skills || []).map(each => ({ ...each, name: each.skill_name, serverSideSkill: !useOnboardingStore.getState().isResumeParsingFlow })),
    deletedSkills: PREFERENCES_SKILLS_FORM_INITIAL_VALUE.deletedSkills
});

export const transformDataPreferenceLanguageData = (data: LanguagesKnown[] | undefined) => {
    const englishProficiencyValue = data?.find(language => language.language_id === "en")?.language_skills?.find(skill => skill.name === "speak")?.proficiency;
    const languagesKnown = data?.reduce((result: LanguagesKnownType[], language) => {
        if (language.language_id !== "en") {
            const tempLang = {
                language_id: language.language_id,
                language_name: language.language_name,
            }
            result.push(tempLang);
        }
        return result;
    }, []) || [];

    return {
        englishProficiency: isNaN(Number(englishProficiencyValue)) ? -1: englishProficiencyValue,
        languagesKnown,
    }
};

export const transformBodyToPreferencesForm = (data: Profile) => {
    const tempData = JSON.parse(JSON.stringify(PREFERENCES_DEFAULT_VALUE));
    tempData.skillsDetails = transformDataPreferenceSkillData(data);
    tempData.languageDetails = transformDataPreferenceLanguageData(data?.known_languages);
    tempData.jobCategoryDetails = { jobCategories: [] };
    tempData.assessmentDetails = {
        telecaller: [],
        delivery: {
            drivingLicense: -1,
            bike: -1,
            rc: -1,
            pc:-1,
            ac:-1,
            "Driving License": {
                twoWheeler: false,
                fourWheeler: false,
            },
            "Bike": "",
            "Vehicle RC": ""
        }
    }
    tempData.preferredJobCity = {}
    tempData.workTypePreferences = STEP_THREE_INITIAL_VALUES
    return tempData;
}

export const transformBodyToTelecallerAssessmentFormData = (data: TelecallerAssessmentResponseType[]) => {
    // find the required question from response
    const question = data?.[0]?.questions?.find(q => q?.id === parseInt(config.telecallingAssesmentQuestionId));

    // get selected option
    const selectedOptions = question?.data.options?.filter(option => option.is_selected) || []
    const answersArr = selectedOptions?.map(option => option.option_id.toString()) || []

    return answersArr;
}

export const transformBodyToDeliveryAssessmentFormData = (data: DeliveryAssessmentResponseType[]) => {
    const questions = data?.[0]?.questions;

    const answersObj: any = {
        assets:[
            "bike"
         ],
         docs:[
            {
               name:"pan-card"
            },
            {
             name: "driving-license",
             extended_docs: ["two-wheeler-dl", "four-wheeler-dl"], // Only for Driving license as of now for 2 wheeler, 4 Wheeler
           },
         ],
         non_available_docs:[
            "aadhar-card"
         ],
         non_available_assets:[
            "car"
         ]
    }

    // options for each question -> question.data.options
    // check for is_selected key in each option
    questions?.map(question => {
        question?.data?.options.map((option) => {
            if(option?.is_selected){
                // const key: DeliveryQuestionKey = deliveryAssessmentIdsMapping?.[question.id];
                // answersObj[key] = option.option_id
            }
        })
    })

    return answersObj;
}

// NB Pref Location helpers:
export const mapNBSearchDataToNBPrefFormData = (data: NBJobLocationSearchData): NBPreferredLocationData => {
    return {
        display_name: data.name,
        is_live: data.is_live,
        city_id: data.location_ids?.city_id,
        cluster_id: data.location_ids?.cluster_id
    }
}
